import { render, staticRenderFns } from "./ForwardForm.vue?vue&type=template&id=17fc21db&"
import script from "./ForwardForm.vue?vue&type=script&lang=js&"
export * from "./ForwardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports